import React, { FC, ReactElement } from 'react';

import { PaymentPlanValues } from 'interfaces/payment/plans';

import styles from './styles.scss';

const StripeFailure: FC<{ plan: PaymentPlanValues }> = ({ plan }): ReactElement => {
  const mailerBody: string = encodeURIComponent(
    'Hello,\n\nI have a question related to setting up on-going access to the SumZero research database. Please reach out to me at your earliest convenience.\n\nThank you!'
  );
  const mailerSubject: string = encodeURIComponent('Question on SumZero Database Access');

  return (
    <div className={styles.serverError}>
      Unable to checkout at this time. Please refresh the page. If the problem persists, contact{' '}
      <a
        href={`mailto:access@sumzero.com?subject=${mailerSubject}&body=${mailerBody}`}
        data-heap={`contact-access-email-failure-${plan}`}
      >
        access@sumzero.com
      </a>
      .
    </div>
  );
};

export default StripeFailure;
